import {Dispatch, SetStateAction} from "react";
import {HistorySearchParamType} from "../interface";
import {SubmitHandler, useForm} from "react-hook-form";
import {useExportHistoryExcel} from "../hooks/useExportHistoryExcel";

interface PropsType {
    searchParam: HistorySearchParamType
    setSearchParam: Dispatch<SetStateAction<HistorySearchParamType>>
    setSelectedHistoryIdx: Dispatch<SetStateAction<number>>
}

export default function Filter({searchParam, setSearchParam, setSelectedHistoryIdx}: PropsType) {
    const {mutate: mutateExportHistoryExcel} = useExportHistoryExcel()

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const btnExportExcel = () => {
        mutateExportHistoryExcel({...searchParam, pageNo: 1, limit: 1000000})
    }

    const onSubmit: SubmitHandler<HistorySearchParamType> = (submitData) => {
        setSearchParam({...submitData, pageNo: 1});
        setSelectedHistoryIdx(-1)
    };

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">재고내역 검색</h3>
            <div className="filter_toolbar">
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt=""/>엑셀 내보내기
                </button>
            </div>
        </div>
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">상태</label>
                    <select className="form-select w-150px" {...register("keywordType")}>
                        <option value={"0"}>전체</option>
                        <option value={"1"}>출고</option>
                        <option value={"2"}>입고</option>
                        <option value={"3"}>조정</option>
                    </select>
                </div>
            </div>
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">재고변경일자</label>
                    <div className="frm_field">
                        <div className="frm_field input_date">
                            <input type="date" className="form-control"
                                   max="9999-12-31"
                                   {...register("startAt")}
                            />
                            <span className="txt_range">~</span>
                            <input type="date" className="form-control me-0"
                                   max="9999-12-31"
                                   {...register("endAt")}
                            />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
}